import { css, type SerializedStyles } from '@emotion/react';

import { SETTINGS_COLORS } from '@/Client/Styles';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { styleguideFontFamily } from '@kaiizen/kai-shiki/core';

export type OrgSettingState = 'enabled' | 'disabled';

export type OrgSettingChipStyles = {
  root: SerializedStyles;
  rootByState: Record<OrgSettingState, SerializedStyles>;
};

export const DEFAULT_ORG_SETTING_CHIP_STYLES: OrgSettingChipStyles = {
  root: css`
    label: ORG_SETTING_CHIP;
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    margin: 4px 0;
    border: 1px solid ${SETTINGS_COLORS.border};
    border-radius: 999px;
    background: ${SETTINGS_COLORS.white};
    color: ${SETTINGS_COLORS.text};
    font-family: ${styleguideFontFamily.body};
    font-weight: 400;
    font-size: ${pxToRem(13)};
    white-space: nowrap;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      border-color: ${SETTINGS_COLORS.text};
    }
  `,
  // Disabled is struck through as well as muted, so the state never rests on color alone.
  rootByState: {
    enabled: css`
      label: ORG_SETTING_CHIP_ENABLED;
      border-color: ${SETTINGS_COLORS.green};
    `,
    disabled: css`
      label: ORG_SETTING_CHIP_DISABLED;
      color: ${SETTINGS_COLORS.textMuted};
      text-decoration: line-through;
    `,
  },
};
